import React, { useEffect } from 'react';

import { useEvent } from '../../utils/analytics/useEvent';
import { usePageLoadEvent } from '../../utils/analytics/usePageLoadEvent';

import { SignUpFormContextProvider } from './SignUpFormContext';
import { SignUpForm } from './form';

export function SignUp() {
  usePageLoadEvent('sign up', 'home');
  const trackEvent = useEvent();

  useEffect(() => {
    trackEvent('identity – mlife registration - start', 'start mlife registration process', 'mliferegstart');
  }, [trackEvent]);

  return (
    <SignUpFormContextProvider>
      <SignUpForm />
    </SignUpFormContextProvider>
  );
}

SignUp.displayName = 'SignUp';
